// Roteamento de topo: o CAMINHO da URL decide a tela (ver lib/rotas.tsx).
//
// Branch web: o portal é SÓ a Área Resulti (o console da equipe) e mora na raiz de
// admin.plugchef.com.br, na mesma origem da API (o Caddy manda `/admin/v1/*` para ela — nenhuma tela
// começa assim):
//
//   /            → login da equipe (com autenticador); já logado, vai para o início
//   /inicio      → boas-vindas
//   /comercial/contratantes[/:id] → os contratantes e a ficha (com "Criar o cliente")
//   /comercial/catalogo           → planos, módulos e adicionais, ciclos (?aba=)
//   /comercial/contratos[/:id]    → os contratos (?busca=&situacao=&cliente=) e a ficha (faturas, cobrança, alterações)
//   /cadastros/globais            → unidades, CFOP, cidades, estados e países (?aba=&busca=&uf=)
//   /cadastros/integracoes        → os aplicativos e as credenciais dos parceiros (?aba=aplicativos|parceiras)
//   /cadastros/plugai             → o PlugAI: motores, pacotes, checks, agentes, clientes (carteiras) e consumo (?aba=…)
//   /suporte                      → escolher o cliente para o suporte (?busca=)
//   /suporte/clientes/:clienteId  → o suporte num cliente: abrir o acesso; com ele, as abas (?aba=&empresa=&de=&ate=&venda=)
//   /suporte/acessos              → os acessos de suporte (?cliente=&situacao=abertos|encerrados&pessoa=)
//   /suporte/instaladores         → os instaladores para baixar à mão (o PlugChef Terminal)
//   /equipe      → a equipe da Resulti
//   /auditoria   → a auditoria (só ADMIN; ?acao=&pessoa=&cliente=&de=&ate=)
//   o resto      → "Página não encontrada" dentro do console (sem sessão → login com ?volta=)
import { lazy, Suspense } from 'react';
import { useLocalizacao } from './lib/rotas';
import { ProvedorSessao } from './store/sessao';
import { PaginaLoginResulti } from './pages/resulti/LoginResulti';
import { TelaCarregando } from './components/base';
import { LOGIN } from './components/console/menu';

// O console (a Motion e as telas) vem sob demanda: a tela de login abre sem baixar nada disso.
const AreaResulti = lazy(() => import('./pages/resulti/AreaResulti').then((m) => ({ default: m.AreaResulti })));

export function App(): JSX.Element {
  const { caminho } = useLocalizacao();
  return (
    <ProvedorSessao>
      {caminho === LOGIN ? (
        <PaginaLoginResulti />
      ) : (
        <Suspense fallback={<TelaCarregando />}>
          <AreaResulti caminho={caminho} />
        </Suspense>
      )}
    </ProvedorSessao>
  );
}
